import styled from 'styled-components';
import { Row, Col } from 'antd';


export const Container = styled.div`
  margin-top: 15vw;
`;
interface ResponsiveProps {
    isCFA?: boolean;
}

export const Content = styled(Row)<ResponsiveProps>`
    background: #FFFFFF;
    box-shadow: 0px 0px 1.408vw rgba(0, 0, 0, 0.05); //40
    border-radius: 0.704vw; //20
    padding: 2.112vw; //60
    height: 25.650vw; //728.48
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: ${props => props.isCFA ? '0.5vw' : '1vw'};
`;

export const ColContent = styled(Col)<ResponsiveProps>`
    display: flex;
    justify-content: flex-start;
    height: ${props => props.isCFA ? '15vw' : '14.7vw'};
    gap: ${props => props.isCFA ? '0' : '3vw'};
    margin-left: ${props => props.isCFA ? '5vw' : '6vw'};
    margin-bottom: ${props => props.isCFA ? '-0.8vw' : '0'};
    ${props => !props.isCFA && `
        flex: 0 0 calc(100% - 6vw);
        max-width: calc(100% - 6vw);
        gap: 0;
    `}
`;

export const Middle = styled.div<ResponsiveProps>`
    position: absolute;
    width: ${props => props.isCFA ? '81.5vw' : 'calc(100% + 6vw)'};
    height: 0px;
    margin-top: 7.4vw;
    margin-right: 5.212vw;
    margin-left: -6vw;
    display: flex;
    p {
        position: absolute;
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: ${props => props.isCFA ? '1vw' : '1.408vw'};
        line-height: 1.725vw; //49
        color: #A4A4A4;
        margin-top: -2vw;
    }
`;


export const LineDashed = styled.div`
    /* background: #C4C4C4; */
    border: 0.076vw dashed #252525; //5
    width: 100%;
    z-index: 0;
`;


export const ColM = styled.div<ResponsiveProps>`
    display: flex;
    justify-content: ${props => props.isCFA ? 'flex-start' : 'center'};
    align-items: center;
    width: ${props => props.isCFA ? '75vw' : '97%'};
    gap: ${props => props.isCFA ? '0' : '4.8vw'};
    margin-left: ${props => props.isCFA ? '4vw' : '0'};
    margin-bottom: 0;
    h3 {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: ${props => props.isCFA ? '1.2vw' : '1.584vw'};
        line-height: ${props => props.isCFA ? '1.5vw' : '1.936vw'};
        width: ${props => props.isCFA ? '7.8vw' : 'auto'};
        text-align: ${props => props.isCFA ? 'center' : 'left'};
        color: #A4A4A4;
    }
    ${props => !props.isCFA && `
        width: calc(100% - 6vw);
        margin-left: 6vw;
        gap: 0;
        h3 {
            flex: 1;
            margin: 0;
            text-align: center;
        }
    `}
`;

export const Line = styled.div<ResponsiveProps>`
    border: 0.0352vw solid #999999;
    width: ${props => props.isCFA ? '78vw' : '71.6vw'};
    height: 0px;
    display: flex;
    justify-content: center;
    margin-left: 3.5vw;
    margin-bottom: 0;
    ${props => !props.isCFA && `
        width: calc(100% - 6vw);
        margin-left: 6vw;
    `}
`;

export const LineDashedTop = styled.div<ResponsiveProps>`
    position: absolute;
    border: 0.020vw dashed #999999; //0.5
    width: 91%;
    z-index: 0;
    margin-top: -7.4vw;
    margin-left: 5.9vw;
`;

export const Wrapper = styled.div`
    width: 100%;
    background: #FFFFFF;
    border: 0.176vw solid #5768FF;//5
    box-sizing: border-box;
    border-radius: 0.704vw; //20
    margin-top: 4.225vw; //120
    padding: 3.873vw; //110
`;


export const LastTitle = styled.div`
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 2.640vw; //75
    line-height: 3.204vw; //91
    color: #000000;
`;


export const Text = styled.div`
    p{
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 1.584vw; //45
        line-height: 2.464vw; //70
        text-align: justify;
        color: #434343;
        margin-top: 2.112vw;
    }
    p:last-child {
        margin-top: 0.112vw;
    }
    span {
        color: #D81E5B;
        font-weight: 600;
    }
`;
